var map = {
	"./1.png": "ed9f",
	"./2.png": "6ea8",
	"./3.png": "1365",
	"./4.png": "ae8ea",
	"./5.png": "3ec6c",
	"./6.png": "a191",
	"./beijing.png": "9245"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ded";